import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlmacenesService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/almacenes/Almacenes';
  }

  obtenerAlmacenes(estacion: string){
    return this.httpClient.get(this.endpoint + `/ObtenerAlmacenes/${estacion}`);
  }

  obtenerAlmacen(estacion: string, combustible: string){
    return this.httpClient.get(this.endpoint + `/ObtenerAlmacen/${estacion}/${combustible}`);
  }

  getAlmacenes(){
    return this.httpClient.get(this.endpoint + `/GetAlmacenes`);
  }

  insertAlmacenes(modelo: any) {
    return this.httpClient.post(this.endpoint + '/InsertAlmacenes', modelo);
  }

  updateAlmacenes(modelo: any) {
    return this.httpClient.post(this.endpoint + '/UpdateAlmacenes', modelo);
  }

}
